require("./aresLoanMovementsView.scss");
const PropTypes = require("prop-types");
// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const PureRenderMixin = require("react-addons-pure-render-mixin");
const { withRouter } = require("react-router-dom");
// @ actions
const { requestLoanMovements } = require("../../actions/loansMovements");
const collectiveActions = require("actions/collectives");
// @ components
const LoanHeader = require("../../components/loansAndMortgages/loans/loanHeader/loanHeader");
const ARESLoanMovements = require("../../components/loansAndMortgages/loans/aresLoanMovements/aresLoanMovements");
const TutorialLauncher = require("components/tutorial/tutorialLauncher");
// @ helpers
const { formatText } = require("core/i18n").i18n;
// @ constants
const {
    GRAPHIC_TUTOR_TYPE_3,
    MULTICHANNEL_UI_COMPONENT,
} = require("constants/index");

class ARESLoanMovementsView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(
            this
        );
    }

    componentDidMount() {
        const {
            requestLoanMovements,
            match: {params: { loanId }},
            immLoans,
            getCollectiveInfo,
        } = this.props;
        const immLoan = immLoans.getIn(["byId", loanId], false);

        if (immLoan && !immLoan.get("isOldLoan")) {
            const productType = {
                type: immLoan.get("product"),
                subType: immLoan.get("productSubType"),
                standard: immLoan.get("productStandard"),
            };

            requestLoanMovements(loanId);
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
        } else {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    buildBreadcrum(immLoan) {
        const loanPrefix = immLoan.get('isPersonal') ? '' : `-${immLoan.get('type')}`;
        return [
            {
                text: formatText("breadcrumb-loans"),
                url: `/myprofile/loans-mortgages`,
            },
            {
                text: immLoan.get("alias"),
                url: `/myprofile/loans-mortgages/ares${loanPrefix}-loans/${immLoan.get(
                    "loanId"
                )}`,
            },
            {
                text: formatText("breadcrumb-movements"),
            },
        ];
    }
    render() {
        const {
            immLoans,
            match: {params: { loanId }},
            immLoanMovements,
        } = this.props;
        const immLoan = immLoans.getIn(["byId", loanId], false);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText("tutorials-loansMovementsTitle")}
            />
        );

        let breadcrumb;

        if (immLoan && !immLoan.get("isOldLoan")) {
            breadcrumb = this.buildBreadcrum(immLoan);
            return (
                <article className="ares-loan-movements-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadcrumb}
                        tutorial={tutorial}
                        isARES
                />
                    <section className="loan-movements-view__body">
                        <div className="row no-outside-gutter">
                            <div className="col-xs-9">
                                <ARESLoanMovements
                                    immLoan={immLoan}
                                    immLoanMovements={immLoanMovements}
                                    loanId={loanId}
                            />
                            </div>
                            <div className="col-xs-3"></div>
                        </div>
                    </section>
                </article>
            );
        }

        return null;
    }
}

ARESLoanMovementsView.propTypes = {
    getCollectiveInfo: PropTypes.func.isRequired,
    immLoans: PropTypes.object.isRequired,
    immLoanMovements: PropTypes.object,
    requestLoanMovements: PropTypes.func.isRequired,
    productAds: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(
    (state) => ({
        immLoans: state.loans,
        immLoanMovements: state.loansMovements,
    }),
    {
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        requestLoanMovements,
    }
)(ARESLoanMovementsView));
